var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVisaCard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 23,
    viewBox: "0 0 31 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.7095 0.666504H2.62254C1.54198 0.666504 0.666016 1.5356 0.666016 2.60768V20.7253C0.666016 21.7974 1.54198 22.6665 2.62254 22.6665H28.7095C29.7901 22.6665 30.666 21.7974 30.666 20.7253V2.60768C30.666 1.5356 29.7901 0.666504 28.7095 0.666504Z",
    fill: "#2566AF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5605 14.7717H14.2621L15.3271 8.5755H13.6249L12.5605 14.7717Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.7579 11.0642C18.1631 10.7775 17.7986 10.586 17.8025 10.2961C17.8025 10.0373 18.1109 9.76292 18.7807 9.76292C19.2743 9.75067 19.7635 9.85653 20.207 10.0716L20.4379 8.72892C19.9486 8.55381 19.4319 8.46618 18.9118 8.4701C17.2299 8.4701 16.0423 9.31127 16.0351 10.5148C16.0259 11.4052 16.8829 11.9021 17.5266 12.1972C18.1892 12.5006 18.4123 12.6941 18.409 12.9652C18.4044 13.3806 17.8801 13.5709 17.3903 13.5709C16.7567 13.5855 16.1298 13.4397 15.5688 13.147L15.3301 14.5337C15.9368 14.7562 16.5791 14.8682 17.2259 14.8643C19.0155 14.8643 20.177 14.0335 20.1901 12.7478C20.1933 12.0425 19.7401 11.5061 18.7579 11.0642Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M24.8012 8.58189H23.4858C23.3009 8.5584 23.1134 8.596 22.9522 8.68887C22.7911 8.78174 22.6653 8.9247 22.5942 9.09565L20.0664 14.7723H21.854C21.854 14.7723 22.1462 14.0088 22.2121 13.8412H24.3923C24.4431 14.0586 24.5997 14.7697 24.5997 14.7697H26.1792L24.8012 8.58189ZM22.7025 12.5762C22.7729 12.3969 23.4675 10.6272 23.6064 10.2526C23.836 11.3202 23.6123 10.2843 24.1151 12.5762H22.7025Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M11.1341 8.58091L9.46712 12.8062L9.28973 11.9476L8.69299 9.1005C8.6495 8.93555 8.54741 8.79175 8.40552 8.69556C8.26364 8.59938 8.09151 8.55728 7.92082 8.57703H5.17582L5.1543 8.70644C5.77842 8.85254 6.3799 9.08128 6.94256 9.3865L8.4556 14.7681H10.2569L12.9367 8.5835L11.1341 8.58091Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisaCard);
export default __webpack_public_path__ + "static/media/visa_card.332aa06675c16b9fb3fc8621d4893106.svg";
export { ForwardRef as ReactComponent };